import { shiftProductionLineNames } from "../../../shared/shift-production-form/contracts";

export const productionLines = shiftProductionLineNames;

export const shiftLabels = {
  "00_08": "VR1",
  "08_16": "VR2",
  "16_00": "VR3",
} as const;
export const shiftOptions = Object.values(shiftLabels);

export const checkItems = [
  "Tank ve boru tesisatı",
  "Hareketli aksam",
  "Muhafaza, sensör ve switch",
  "Kalıp",
  "Bobin, ambalaj, etiket ve koli",
] as const;

export const controlStates = [
  "Uygun",
  "Uygun Değil",
  "Kontrol Edilmedi",
  "Uygulanmaz",
] as const;
export const measurementStates = [
  "Ölçüldü",
  "Ölçülmedi",
  "Uygulanmaz",
] as const;
